import api from "@/api";

const namespaced = true

const state = {
  dockingSchedules: [],
  owners: [],
  categories: [],
  status: [],
  dockingSchedulesFiles: {},
  tugsBarges: []
}

const getters = {
  dockingSchedules: state => state.dockingSchedules,
  owners: state => state.owners,
  categories: state => state.categories,
  status: state => state.status,
  dockingSchedulesFiles: state => state.dockingSchedulesFiles,
  tugsBarges: state => state.tugsBarges
}

const mutations = {
  SET_DOCKING_SCHEDULES: (state, payload) => {
    state.dockingSchedules = payload
  },
  SET_OWNERS: (state, payload) => {
    state.owners = payload
  },
  SET_CATEGORIES: (state, payload) => {
    state.categories = payload
  },
  SET_STATUS: (state, payload) => {
    state.status = payload
  },
  SET_DOCKING_SCHEDULES_FILES: (state, payload) => {
    state.dockingSchedulesFiles = payload
  },
  SET_TUGS_BARGES: (state, payload) => {
    state.tugsBarges = payload
  }
}

const actions = {
  async fetchDockingSchedules({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']

      if (payload) {
        if (payload.hasOwnProperty('sort_dir')) {
          payload ['sort_dir'] = payload['sort_dir'].toUpperCase()
        }
        else if (!payload.hasOwnProperty('sort_dir') && !payload.hasOwnProperty('sort_by')) {
          payload['sort_dir'] = 'ASC'
          payload['sort_by'] = 'schedule'
        }
      }
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload
      }

      const { data } = await api.getDockingSchedules(filter)
      if (data.error) {
        commit('SET_DOCKING_SCHEDULES', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_DOCKING_SCHEDULES', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch(err) {
      throw err
    }
  },
  async fetchOwners  ({ commit }) {
    try {
      const { data } = await api.getDockingScheduleDropdown({
        type: 'OWNER'
      })
      if (data.error) {
        commit('SET_OWNERS', [])
        return
      }

      commit('SET_OWNERS', data)
    } catch (err) {
      throw err
    }
  },
  async fetchStatus({ commit }) {
    try {
      const { data } = await api.getDockingScheduleDropdown({
        type: 'DOCKING_STATUS'
      })
      if (data.error) {
        commit('SET_STATUS', [])
        return
      }

      commit('SET_STATUS', data)
    } catch (err) {
      throw err
    }
  },
  async fetchTugsBarges({ commit }, payload) {
    try {
      if (payload?.category) payload.category = payload.category.toUpperCase()
      const { data } = await api.getDockingScheduleDropdown(payload)
      if (data.error) {
        commit('SET_TUGS_BARGES', [])
        return
      }

      commit('SET_TUGS_BARGES', data)
    } catch (err) {
      throw err
    }
  },
  async postDockingSchedule(_, payload) {
    try {
      await  api.postDockingSchedule(payload)
    } catch ({ data }) {
      throw data
    }
  },
  async deleteDockingSchedule (_, payload) {
    try {
      await api.deleteDockingSchedule(payload)
    } catch (err) {
      throw err
    }
  },
  async downloadDockingSchedules({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']

      if (payload && payload.hasOwnProperty('sort_dir')) {
        payload ['sort_dir'] = payload['sort_dir'].toUpperCase()
      }
      const filter = {
        search: filterConfig.search,
        ...payload
      }

      const response = await api.getDockingSchedulesExcelDownload(filter)
      if (response) {
        commit('SET_DOCKING_SCHEDULES_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  async postDockingScheduleSendEmail(_, payload) {
    try {
      const { data } = await api.postDockingScheduleSendEmail(payload)
      if (data.error) {
        return
      }
      return data.data
    } catch (error) {
      throw error
    }
  },
  async postDocumentTrackingReportSendEmail(_, payload) {
    try {
      const { data } = await api.postDocumentTrackingReportSendEmail(payload)
      if (data.error) {
        return
      }
      return data.data
    } catch (error) {
      throw error
    }
  },
  resetDockingSchedulesFiles({ commit }) {
    commit('SET_DOCKING_SCHEDULES_FILES', {})
  },
  async putDockingSchedule(_, payload) {
    try {
      await api.putDockingSchedule(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  }
}

export default { namespaced, state, getters, mutations, actions }